import React, { useState } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import Password from '../../components/Password';
import { resetPassword } from '../../api/authentication';
import Grid from '@mui/material/Grid2';

const ConfirmResetFromEmail = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [passwordOne, setPasswordOne] = useState('');
  const [passwordTwo, setPasswordTwo] = useState('');
  const [passwordText, setPasswordText] = useState('');

  const resetForm = () => {
    setPasswordOne('');
    setPasswordTwo('');
  };

  const validatePassword = () => {
    if (passwordOne !== passwordTwo) {
      setPasswordText('Passwords do not match');
      setPasswordOne('');
      setPasswordTwo('');
      return false;
    }
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!regex.test(passwordOne)) {
      setPasswordText(
        'Password must be minimum 8 characters, at least one uppercase letter, one lowercase letter, one number, and one special character from (@ $ ! % * ? &)'
      );
      resetForm();
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validatePassword()) return;

    try {
      const data = await resetPassword({ password: passwordOne, token });
      if (data.message === 'Password used previously.') {
        setPasswordText(data.message);
        resetForm();
        return;
      }

      const status = data[0].completed;
      if (status === 'Token is invalid or has expired') {
        setPasswordText('Token has expired or is invalid. Please request a new password reset.');
        resetForm();
      } else if (status === 'Password reset') {
        navigate('/');
      }
    } catch (err) {
      setPasswordText('An error occurred. Please try again later.');
      console.error(err);
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} className="authentication-container">
          <Grid size={8} className="authentication-container-inner">
            <div className="authentication-header">Create Password</div>
            <form onSubmit={handleSubmit} id="authentication-form" className="confirm-reset">
              <Box sx={{ marginBottom: '20px' }}>
                <Typography>
                  Create a new password for your existing account. Password must be minimum 8 characters, at least one
                  uppercase letter, one lowercase letter, one number, and one special character from (@ $ ! % * ? &).
                </Typography>
              </Box>
              {passwordText && <Box sx={{ color: 'error.main', marginBottom: '20px' }}>{passwordText}</Box>}
              <Password
                name="username"
                label="Choose a Password"
                value={passwordOne}
                onChange={(e) => setPasswordOne(e.target.value)}
              />

              <Password
                name="password"
                label="Confirm Password"
                value={passwordTwo}
                onChange={(e) => setPasswordTwo(e.target.value)}
              />
              <input id="token" type="hidden" name="token" value={token} />

              <button style={{ marginTop: '0.1rem', maxWidth: '8rem' }} className="authentication-button">
                Continue
              </button>
            </form>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>
    </Container>
  );
};

export default ConfirmResetFromEmail;
